import HBusService from 'Service/HBusService';

export const tradeInCloseEvent = (options = {}) => {
  HBusService.sendEventRequest('DrawerClick', {
    DrawerStatus: 'Closed',
    Placement: 'InstantGratification',
    ...options
  });
};

export const tradeInViewEvent = (options = {}) => {
  HBusService.sendEventRequest('TradeinDrawer', {
    page_type: 'Tradein',
    page_value: 'DeviceInfo',
    step_number: '1',
    ...options
  });
};

export const moveOnDeviceSelection = ({ buyingCategoryId, brandName, modelName }, options = {}) => {
  HBusService.sendEventRequest('DeviceSelection', {
    page_type: 'pdp',
    placement: 'tradein',
    text: 'devam et',
    bCategory: [buyingCategoryId],
    deviceInfo: [{ brand: brandName, model: modelName }],
    ...options
  });
};

export const offerTypeSelectionViewEvent = (options = {}) => {
  HBusService.sendEventRequest('TradeinDrawer', {
    page_type: 'Tradein',
    page_value: 'OfferTypeSelection',
    step_number: '3',
    ...options
  });
};

export const preOfferViewEvent = (options = {}) => {
  HBusService.sendEventRequest('TradeinDrawer', {
    page_type: 'Tradein',
    page_value: 'PreOffer',
    step_number: '2',
    ...options
  });
};

export const moveOnPreOfferEvent = (
  { buyingCategoryId, proposedAmount, additionalPaymentAmount },
  options = {}
) => {
  HBusService.sendEventRequest('PreOfferDisplay', {
    page_type: 'pdp',
    placement: 'tradein',
    bCategory: [buyingCategoryId],
    proposedAmount,
    additionalpaymentAmount: additionalPaymentAmount,
    text: 'devam et',
    ...options
  });
};

export const DeviceStatusViewEvent = (options = {}) => {
  HBusService.sendEventRequest('TradeinDrawer', {
    page_type: 'Tradein',
    page_value: 'DeviceSituation',
    step_number: '3',
    ...options
  });
};

export const moveOnDeviceStatusEvent = ({ buyingCategoryId, questions }, options = {}) => {
  HBusService.sendEventRequest('DeviceQuestion', {
    page_type: 'pdp',
    placement: 'tradein',
    bCategory: [buyingCategoryId],
    devicecondition: questions?.map(question => ({
      questionId: question.questionId,
      answer: question.selectedAnswerId
    })),
    text: 'devam et',
    ...options
  });
};

export const ImeiCheckViewEvent = (options = {}) => {
  HBusService.sendEventRequest('TradeinDrawer', {
    page_type: 'Tradein',
    page_value: 'DeviceImei',
    step_number: '4',
    ...options
  });
};

export const imeiBottomSheetViewEvent = (options = {}) => {
  HBusService.sendEventRequest('TradeinDrawer', {
    page_type: 'Tradein',
    page_value: 'device_imei_bottom_sheet',
    step_number: '5',
    ...options
  });
};

export const imeiIneligibleViewEvent = (options = {}) => {
  HBusService.sendEventRequest('TradeinDrawer', {
    page_type: 'Tradein',
    page_value: 'imei_ineligible',
    step_number: '6',
    ...options
  });
};

export const addressInfoViewEvent = (options = {}) => {
  HBusService.sendEventRequest('TradeinDrawer', {
    page_type: 'Tradein',
    page_value: 'AddressInfo',
    step_number: '7',
    ...options
  });
};

export const moveOnImeiCheckEvent = (
  { buyingCategoryId, brandName, modelName, netGratification, instant, campaign },
  options = {}
) => {
  HBusService.sendEventRequest('ImeiFilled', {
    page_type: 'pdp',
    placement: 'tradein',
    bCategory: [buyingCategoryId],
    deviceInfo: [{ brand: brandName, model: modelName }],
    proposalSummary: [
      {
        totalpayment: netGratification,
        preOffer: instant?.amount?.value,
        additionalPayment: campaign?.amount?.value
      }
    ],
    text: 'Ürünü sepete ekle ve devam et',
    ...options
  });
};

export const moveOnBrandModelLinkClickEvent = (
  { brandName, modelName, location },
  options = {}
) => {
  HBusService.sendEventRequest('LinkClick', {
    page_type: 'pdp',
    placement: 'tradein',
    brand: brandName,
    model: modelName,
    text: 'Marka ekranı devam et',
    location,
    ...options
  });
};

export const moveOnOfferLinkClickEvent = ({ tradeInType, location }, options = {}) => {
  HBusService.sendEventRequest('LinkClick', {
    page_type: 'pdp',
    placement: 'tradein',
    offerType: tradeInType,
    location,
    text: 'Pre Offer ekranı devam et',
    ...options
  });
};

export const selectDoorRadioLinkClickEvent = ({ tradeInType, location }, options = {}) => {
  HBusService.sendEventRequest('DoorEvent', {
    page_type: 'pdp',
    placement: 'tradein',
    trade_in_type: tradeInType,
    location,
    text: 'Selection Screen devam et',
    ...options
  });
};

export const moveOnDeviceQuestionLinkClickEvent = (
  { buyingCategoryId, deviceCondition },
  options = {}
) => {
  HBusService.sendEventRequest('DeviceQuestion', {
    page_type: 'pdp',
    placement: 'tradein',
    bCategory: [buyingCategoryId],
    device_condition: deviceCondition,
    text: 'devam et',
    ...options
  });
};

export const AddToCartClickEvent = (options = {}) => {
  HBusService.sendEventRequest('AddToCart', {
    page_type: 'TradeIn',
    placement: 'pdp',
    text: 'Ürünü sepete ekle',
    ...options
  });
};

export default {
  tradeInCloseEvent,
  tradeInViewEvent,
  moveOnDeviceSelection,
  preOfferViewEvent,
  moveOnPreOfferEvent,
  DeviceStatusViewEvent,
  moveOnDeviceStatusEvent,
  ImeiCheckViewEvent,
  moveOnImeiCheckEvent,
  moveOnBrandModelLinkClickEvent,
  moveOnOfferLinkClickEvent,
  selectDoorRadioLinkClickEvent,
  moveOnDeviceQuestionLinkClickEvent,
  AddToCartClickEvent
};
